module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAKlJREFUaEPtlkEKwDAMw5r/Pzo7j10MQawO3tkzjZRC65h/ZX7+kwH+NhgDMTAkkBUaAhz/vs9Ad/cYC1hQVS/oHwP2A4DwkOp9dwDBBJbGAAhXqo4BCRMYigEQrlS9z4D9U8J+AGnxLgrtuwMXwZWOEgMSJjAUAyBcqToGJExgaJ8B+6eE/QDguiLV++4AggksjQEQrlQdAxImMBQDIFypOgYkTGDI3sADTukYMU/0+JoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ic_caidan@2x.png
// module id = uqoa
// module chunks = 1